import { useMutation, useQueryClient } from "@tanstack/react-query";
import { client } from "@/lib/hono";
import toast from "@/lib/toast";
import { t } from "@/lib/localization";

export const useDeleteAvatar = () => {
    const qc = useQueryClient();
    return useMutation<unknown, Error, { id: string }>({
        mutationKey: ["deleteAvatar"],
        mutationFn: async ({ id }) => {
            const response = await client.api.avatars.heygen.avatars[":id"]["delete"].$delete({
                param: { id },
            });
            if (!response.ok) throw new Error("Failed to delete avatar");
            return await response.json();
        },
        onSuccess: () => {
            toast.success(t("avatars.toast.delete-avatar.success"), {
                keyName: "avatars.toast.delete-avatar.success",
            });
            qc.invalidateQueries({ queryKey: ["avatars"] });
        },
        onError: () => {
            toast.error(t("avatars.toast.delete-avatar.error"), {
                keyName: "avatars.toast.delete-avatar.error",
            });
        },
    });
};

export const useDeleteAvatarLook = () => {
    const qc = useQueryClient();
    return useMutation<unknown, Error, { lookId: string; avatarId: string }>({
        mutationKey: ["deleteAvatarLook"],
        mutationFn: async ({ lookId }) => {
            const response = await client.api.avatars.heygen.avatars.looks[":lookId"][
                "delete"
            ].$delete({ param: { lookId } });
            if (!response.ok) throw new Error("Failed to delete look");
            return await response.json();
        },
        onSuccess: (_data, { avatarId }) => {
            toast.success(t("avatars.toast.delete-look.success"), {
                keyName: "avatars.toast.delete-look.success",
            });
            qc.invalidateQueries({ queryKey: ["avatars"] });
            qc.invalidateQueries({ queryKey: ["avatar", avatarId] });
        },
        onError: () => {
            toast.error(t("avatars.toast.delete-look.error"), {
                keyName: "avatars.toast.delete-look.error",
            });
        },
    });
};
